import _ from 'lodash';
import {Measure} from './Measure';

export class BubbleData {
  constructor(state) {
    this._init(state);
  }

  _init(state) {
    const {title, name, type, data, category, columns, measures} = state;

    const columnFilter = column => !column.hidden;

    const axisData = _(columns)
        .filter(columnFilter)
        .value();

    const xMeasure = new Measure(measures[0], data);
    const yMeasure = new Measure(measures[1], data);

    const axis = {
      x: axisData[0],
      y: axisData[1],
      size: axisData[2],
      measure: {
        x: xMeasure,
        y: yMeasure
      },
      pad: {
        x: Math.max(Math.abs(xMeasure.measure('max')), Math.abs(xMeasure.measure('min'))) * 0.05,
        y: Math.max(Math.abs(yMeasure.measure('max')), Math.abs(yMeasure.measure('min'))) * 0.05
      }
    };

    const series = [{
      xField: axis.x.field,
      yField: axis.y.field,
      sizeField: axis.size.field,
      categoryField: category.field
    }];

    this.axis = axis;
    this.category = category;
    this.dataSource = data;
    this.series = series;
    this.name = name;
    this.title = title;
    this.type = type;
  }
}
